import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Paper, Slide, type SxProps, type Theme } from "@mui/material";
import type { FC } from "react";

interface SlideCardProps {
	open: boolean;
	title: string;
	children: JSX.Element | JSX.Element[];
	action?: React.ReactNode;
	sx?: SxProps<Theme>;
	customWidth?: object;
}

export const SlideCard: FC<SlideCardProps> = ({
	open,
	children,
	action,
	sx,
	title,
	customWidth,
}) => {
	return (
		<Slide direction="up" in={open} mountOnEnter unmountOnExit>
			<Paper
				sx={{
					position: "fixed",
					bottom: 0,
					left: 0,
					right: 0,
					zIndex: 3,
					width: customWidth
						? customWidth
						: {
								xs: "70%",
								sm: "50%",
								md: "30%",
								lg: "20%",
							},
					margin: "2rem auto",
					boxShadow: (t) => t.shadows[9],
				}}
			>
				<BaseCard title={title} action={action} sx={{ ...sx }}>
					{children}
				</BaseCard>
			</Paper>
		</Slide>
	);
};
